/* Generated by packages/brand/scripts/build-themes.mjs. Do not edit. */
export const mermaidThemes = {
  "light": {
    "theme": "base",
    "themeVariables": {
      "background": "#f3f8fa",
      "primaryColor": "#d1f3f6",
      "primaryTextColor": "#081114",
      "primaryBorderColor": "#00808d",
      "secondaryColor": "#e5edef",
      "secondaryTextColor": "#081114",
      "secondaryBorderColor": "#adbabe",
      "tertiaryColor": "#f9fcfe",
      "tertiaryTextColor": "#081114",
      "tertiaryBorderColor": "#cfd9dd",
      "lineColor": "#435358",
      "textColor": "#081114",
      "mainBkg": "#f9fcfe",
      "nodeBorder": "#00808d",
      "clusterBkg": "#e5edef",
      "clusterBorder": "#adbabe",
      "edgeLabelBackground": "#f9fcfe",
      "noteBkgColor": "#d1f3f6",
      "noteTextColor": "#081114",
      "noteBorderColor": "#00808d",
      "fontFamily": "'IBM Plex Sans', ui-sans-serif, system-ui, sans-serif"
    }
  },
  "dark": {
    "theme": "base",
    "themeVariables": {
      "background": "#020708",
      "primaryColor": "#052c30",
      "primaryTextColor": "#e5edef",
      "primaryBorderColor": "#17bac8",
      "secondaryColor": "#040a0d",
      "secondaryTextColor": "#e5edef",
      "secondaryBorderColor": "#29383d",
      "tertiaryColor": "#081114",
      "tertiaryTextColor": "#e5edef",
      "tertiaryBorderColor": "#162125",
      "lineColor": "#adbabe",
      "textColor": "#e5edef",
      "mainBkg": "#081114",
      "nodeBorder": "#17bac8",
      "clusterBkg": "#040a0d",
      "clusterBorder": "#29383d",
      "edgeLabelBackground": "#162125",
      "noteBkgColor": "#052c30",
      "noteTextColor": "#e5edef",
      "noteBorderColor": "#17bac8",
      "fontFamily": "'IBM Plex Sans', ui-sans-serif, system-ui, sans-serif"
    }
  }
} as const;
export type MermaidThemeName = keyof typeof mermaidThemes;
